import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import _flatMap from 'lodash/flatMap';
import _includes from 'lodash/includes';
import _intersection from 'lodash/intersection';
import _pull from 'lodash/pull';
import _find from 'lodash/find';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';
import { ButtonV2 } from '@zola/zola-ui';

import { NAV_DATA } from 'constants/navConstants';
import SecondaryNavV2 from 'components/common/header/SecondaryNavV2';

import StickyHeaderTable from '../../common/ui/StickyHeaderTable';
import { showModal, hideModal } from '../../../actions/ModalActions';
import {
  fetchBuildList,
  getGuestGroup,
  toggleBuildFacetValue,
  toggleSortByNameAsc,
  selectEventTab,
  updateEventInvitation,
  bulkUpdateAllEventInvites
} from '../../../actions/GuestActions';
import { resetMapping } from '../../../actions/GuestImportActions';
import GlobalStats from '../common/GlobalStats';
import Facets from './Facets';
import { PrefixToLabel } from './GuestListTypes';
import Loader from '../../common/ui/Loader';
import { isNameUnknown } from './util';
import { getGuestGroupRsvpByUuid } from '../../../actions/PublicWebsiteActions';
import { EmptyState } from './EmptyState';
// import { updateRsvpPageVisibility } from '../../../actions/EventActions';

import NoGuestsOnboardFormV2 from './noGuestsOnboardFormV2/NoGuestsOnboardFormV2';
import NoGuestValueProps from './noGuestValueProps/NoGuestValueProps';
import MatchGuestList from './upload/MatchGuestList';

import eventsCalendar from '../../../assets/images/pages/event.png';
import featureFlags from '../../../util/featureFlags';

const navRedesign = featureFlags.get('navRedesign');
const gmPhase1 = featureFlags.get('guestManagerP1');

class GuestGroupRow extends Component {
  constructor(props) {
    super(props);

    this.rowCheck = this.rowCheck.bind(this);
    this.rowClick = this.rowClick.bind(this);
    this.updateInvitedToEvent = this.updateInvitedToEvent.bind(this);
    this.showEventUpdated = this.showEventUpdated.bind(this);
    this.hideEventUpdated = this.hideEventUpdated.bind(this);

    this.state = {
      active: true,
      timeout: null,
      eventUpdated: {
        id: null,
        invited: null
      }
    };
  }

  componentWillReceiveProps(nextProps) {
    const { modalOpen, onSelectGuestGroup } = this.props;
    if (modalOpen && (nextProps.modalOpen === false)) {
      this.setState({
        timeout: setTimeout(() => onSelectGuestGroup(null), 1000)
      });
    }
    // console.log(nextProps.guestGroup.guests); // eslint-disable-line
  }

  componentWillUnmount() {
    const { timeout } = this.state;
    if (timeout) {
      clearTimeout(timeout);
    }
  }

  rowCheck() {
    const { guestGroup, onRowCheck, isRowChecked } = this.props;
    onRowCheck(guestGroup.id, !isRowChecked);
  }

  rowClick(e) {
    const { guestGroup, onEditGuestGroup, onSelectGuestGroup } = this.props;
    if (e.target.hasAttribute('data-no-edit')) {
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
    } else {
      onEditGuestGroup(guestGroup.id);
      onSelectGuestGroup(guestGroup.id);
    }
  }

  isGuestInvitedToEvent(guestGroup, eventId) {
    const eventInvitations = _
      .flatMap(guestGroup.guests, guest => guest.event_invitations)
      .filter(eventInvitation => eventInvitation.event_id === eventId);
    return eventInvitations.length > 0;
  }

  updateInvitedToEvent(guestGroup, eventId) {
    const { onUpdateEventInvitation } = this.props;
    const { timeout } = this.state;
    const invited = this.isGuestInvitedToEvent(guestGroup, eventId);
    if (!invited) {
      onUpdateEventInvitation([guestGroup.id], eventId, !invited, false);
      if (timeout) {
        clearTimeout(this.state.timeout);
        this.setState({
          timeout: null
        });
      }
      this.showEventUpdated(eventId, !invited);
    } else {
      const eventInvitations = _flatMap(guestGroup.guests, guest => guest.event_invitations);
      const hasResponses = eventInvitations.some(eventInvitation => eventInvitation.event_id === eventId && eventInvitation.rsvp_at !== null);
      onUpdateEventInvitation([guestGroup.id], eventId, !invited, hasResponses);
      if (timeout) {
        clearTimeout(this.state.timeout);
        this.setState({
          timeout: null
        });
      }
      if (!hasResponses) {
        this.showEventUpdated(eventId, !invited);
      }
    }
    // console.log(invited);
  }

  showEventUpdated(id, invited) {
    this.setState({
      eventUpdated: {
        id,
        invited
      },
      timeout: setTimeout(() => this.hideEventUpdated(), 1000)
    });
  }

  hideEventUpdated() {
    this.setState({
      eventUpdated: {
        id: null,
        invited: null
      }
    });
  }

  render() {
    const {
      wedding,
      guestGroup,
      isRowChecked,
      onSelectGuestGroup,
      isActive,
      events,
    } = this.props;
    const { eventUpdated } = this.state;

    const [primaryGuest, ...otherGuests] = guestGroup.guests;
    const numEventsInvitedTo = guestGroup.guests.reduce((sum, guest) => sum + guest.event_invitations.length, 0);

    return (
      <tr
        className={isActive ? 'table-row table-row-active' : 'table-row'}
        onClick={this.rowClick}
        onMouseEnter={() => onSelectGuestGroup(guestGroup.id)}
      >
        <td>
          <div className="checkbox checkbox-table checkbox-secondary">
            <label htmlFor={`guests-${guestGroup.id}`} data-no-edit>
              <input
                type="checkbox"
                id={`guests-${guestGroup.id}`}
                data-no-edit
                checked={isRowChecked}
                onClick={this.rowCheck}
              />
              <span className="input-override" data-no-edit><i className="zolaicon zolaicon-checkmark" data-no-edit /></span>
            </label>
          </div>
        </td>
        <td className="guest-group-list">
          <div>{PrefixToLabel[primaryGuest.prefix]} {primaryGuest.first_name} <strong>{primaryGuest.family_name}</strong></div>
          <ul className="list-indent" style={{ paddingLeft: 0 }}>
            {otherGuests.length > 0 && otherGuests.map(otherGuest => (
              <li key={otherGuest.id}>
                {isNameUnknown(otherGuest) ? (
                  <span>{otherGuest.relationship_type === 'CHILD' ? 'Child' : 'Guest'}</span>
                ) : (
                  <span>{PrefixToLabel[otherGuest.prefix]} {otherGuest.first_name} {otherGuest.family_name}</span>
                )}
              </li>
            ))}
          </ul>
        </td>
        <td>
          <div>{guestGroup.guests.length}</div>
        </td>
        {events && events.orderedIds.map(eventId => (
          <td key={eventId} style={{ textAlign: 'center' }}>
            <div className="checkbox checkbox-table checkbox-secondary">
              <label htmlFor={`guest-${guestGroup.id}-invited-to-event-${eventId}`} data-no-edit>
                <input
                  type="checkbox"
                  id={`guest-${guestGroup.id}-invited-to-event-${eventId}`}
                  checked={this.isGuestInvitedToEvent(guestGroup, eventId)}
                  onChange={() => this.updateInvitedToEvent(guestGroup, eventId)}
                  data-no-edit
                />
                <span className="input-override" data-no-edit><i className="zolaicon zolaicon-checkmark" data-no-edit /></span>
              </label>
            </div>
            <div style={{ position: 'relative' }}>
              {eventUpdated.id === eventId && (
                <span style={{ position: 'absolute', bottom: '-10px', left: 0, fontSize: '12px', width: '100%', textAlign: 'center', whiteSpace: 'nowrap' }}>
                  {eventUpdated.invited ? 'Added to guest list' : 'Removed from guest list'}
                </span>
              )}
            </div>
          </td>
        ))}
        {!events.rsvpPageHidden && numEventsInvitedTo > 0 ? (
          <td className="preview-buttons">
            <Link className="text-button preview-button" to={`/wedding/${wedding.slug}/rsvp/${guestGroup.uuid}`} target="_blank" rel="noopener noreferrer" data-no-edit>Preview <span className="hidden-xs">RSVP Page </span>&rsaquo;</Link>
          </td>
        ) : (
          <td>&nbsp;</td>
        )}
      </tr>
    );
  }
}

GuestGroupRow.propTypes = {
  wedding: PropTypes.shape({}).isRequired,
  guestGroup: PropTypes.shape({}),
  onEditGuestGroup: PropTypes.func.isRequired,
  onRowCheck: PropTypes.func.isRequired,
  isRowChecked: PropTypes.bool.isRequired,
  onSelectGuestGroup: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool,
  isActive: PropTypes.bool,
  events: PropTypes.shape({}),
  onUpdateEventInvitation: PropTypes.func,
  // onGetGuestGroupRsvp: PropTypes.func,
};


class BuildHeader extends Component { // eslint-disable-line
  render() {
    const {
      checkAllRows,
      checkedAllRows,
      sortByNameAsc,
      onToggleSort,
      headerStyle,
      events
    } = this.props;

    return (
      <thead className="table-header" style={headerStyle}>
        <tr>
          <th className="td-checkbox">
            <div className="checkbox checkbox-table">
              <label htmlFor="guests-select-all">
                <input
                  type="checkbox"
                  id="guests-select-all"
                  onClick={checkAllRows}
                  checked={checkedAllRows}
                />
                <span className="input-override">
                  <div className="with-tooltip no-tooltip-on-mobile" data-tooltip="Select all guests on this page.">
                    <i className="zolaicon zolaicon-checkmark" />
                  </div>
                </span>
              </label>
            </div>
          </th>
          <th className="sortable" role="button" onClick={onToggleSort}>
            <div className="with-tooltip visible-md visible-lg" data-tooltip="View guests by last name, ascending or descending."><span className="tooltip-span">Name <i className={`zolaicon zolaicon-arrow-${sortByNameAsc ? 'up' : 'down'}`} /></span></div>
            <div className="visible-xs visible-sm">Name <i className={`zolaicon zolaicon-arrow-${sortByNameAsc ? 'up' : 'down'}`} /></div>
          </th>
          <th>
            <div className="with-tooltip no-tooltip-on-mobile" data-tooltip="Total guests in party">
              <span className="tooltip-span">NO.</span>
            </div>
          </th>
          {events && events.orderedIds.map(eventId => (
            <th key={eventId} style={{ textAlign: 'center' }} className="rsvp-table-header">
              <div className="rsvp-header-name">
                {events.byId[eventId].name.length > 30 ? `${events.byId[eventId].name.slice(0, 30)}...` : events.byId[eventId].name}
              </div>
              <div className="text-muted rsvp-table-subheader" style={{ textTransform: 'none', fontWeight: 300, letterSpacing: 1 }}>
                {events.byId[eventId].collect_rsvps ? 'Online RSVP Enabled' : 'Online RSVP Disabled'}
              </div>
            </th>
          ))}
          <th>&nbsp;</th>
        </tr>
      </thead>
    );
  }
}

BuildHeader.propTypes = {
  headerStyle: PropTypes.objectOf(PropTypes.string),
  checkAllRows: PropTypes.func.isRequired,
  checkedAllRows: PropTypes.bool.isRequired,
  sortByNameAsc: PropTypes.bool.isRequired,
  onToggleSort: PropTypes.func.isRequired,
  events: PropTypes.shape({})
};

// must be a class component for sticky header to work properly
class BuildTable extends Component { // eslint-disable-line
  render() {
    const {
      wedding,
      checkAllRows,
      checkedAllRows,
      sortByNameAsc,
      onToggleSort,
      filteredIds,
      selectedGuestGroupId,
      guestGroups,
      onEditGuestGroup,
      checkedRows,
      checkRow,
      onSelectGuestGroup,
      editGuestModalOpen,
      headerStyle,
      events,
      tableId,
      onUpdateEventInvitation,
      onGetGuestGroupRsvp,
    } = this.props;

    return (
      <table className="table guest-table-v2 table-fixed-header-round round-bottom" id={tableId}>
        <BuildHeader
          events={events}
          checkAllRows={checkAllRows}
          checkedAllRows={checkedAllRows}
          sortByNameAsc={sortByNameAsc}
          onToggleSort={onToggleSort}
          style={headerStyle}
        />
        <tbody>
          {filteredIds.map(guestGroupId => (
            <GuestGroupRow
              key={guestGroupId}
              wedding={wedding}
              isActive={selectedGuestGroupId === guestGroupId}
              guestGroup={guestGroups[guestGroupId]}
              onEditGuestGroup={onEditGuestGroup}
              isRowChecked={_includes(checkedRows, guestGroupId)}
              onRowCheck={checkRow}
              onSelectGuestGroup={onSelectGuestGroup}
              modalOpen={editGuestModalOpen}
              events={events}
              onUpdateEventInvitation={onUpdateEventInvitation}
              onGetGuestGroupRsvp={onGetGuestGroupRsvp}
            />
          ))}
        </tbody>
      </table>
    );
  }
}

BuildTable.defaults = {
  headerStyle: {},
  selectedGuestGroupId: null
};

BuildTable.propTypes = {
  wedding: PropTypes.shape({}).isRequired,
  headerStyle: PropTypes.objectOf(PropTypes.string),
  checkedAllRows: PropTypes.bool.isRequired,
  sortByNameAsc: PropTypes.bool.isRequired,
  editGuestModalOpen: PropTypes.bool.isRequired,
  selectedGuestGroupId: PropTypes.number,
  filteredIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  checkedRows: PropTypes.arrayOf(PropTypes.number).isRequired,
  guestGroups: PropTypes.shape({}).isRequired,
  onEditGuestGroup: PropTypes.func.isRequired,
  onToggleSort: PropTypes.func.isRequired,
  checkRow: PropTypes.func.isRequired,
  checkAllRows: PropTypes.func.isRequired,
  onSelectGuestGroup: PropTypes.func.isRequired,
  events: PropTypes.shape({}),
  tableId: PropTypes.string,
  onUpdateEventInvitation: PropTypes.func,
  onGetGuestGroupRsvp: PropTypes.func,
};

class Build extends Component {
  constructor(props) {
    super(props);

    this.checkRow = this.checkRow.bind(this);
    this.checkAllRows = this.checkAllRows.bind(this);
    this.unCheckAllRows = this.unCheckAllRows.bind(this);
    this.resetFacets = this.resetFacets.bind(this);
    this.resetAll = this.resetAll.bind(this);
    this.afterExport = this.afterExport.bind(this);
    this.selectEventTab = this.selectEventTab.bind(this);
    this.showAllGuests = this.showAllGuests.bind(this);
    this.updateFlowRunId = this.updateFlowRunId.bind(this);
    // this.handlePageToggle = this.handlePageToggle.bind(this);

    this.state = {
      checkedRows: [],
      checkedAllRows: false,
      flowRunId: undefined,
    };
  }

  componentDidMount() {
    const { getGuestList, getEvents } = this.props; // eslint-disable-line
    getGuestList();
    getEvents();
  }

  componentWillReceiveProps(nextProps) {
    const { filteredIds } = nextProps;
    const { checkedRows } = this.state;

    const nextCheckedRows = _intersection(checkedRows, filteredIds);
    const nextCheckedAllRows = nextCheckedRows.length !== 0 && nextCheckedRows.length === filteredIds.length;

    this.setState({
      checkedRows: nextCheckedRows,
      checkedAllRows: nextCheckedAllRows,
    });
  }

  componentWillUnmount() {
    const { onUnload } = this.props;
    onUnload();
    this.resetAll();
  }

  checkRow(id, isChecked) {
    const { filteredIds } = this.props;
    const { checkedRows } = this.state;

    if (isChecked) {
      checkedRows.push(id);
    } else {
      _pull(checkedRows, id);
    }

    this.setState({
      checkedRows,
      checkedAllRows: filteredIds.length === checkedRows.length
    });
  }

  checkAllRows() {
    const { filteredIds } = this.props;
    const checkedAllState = !this.state.checkedAllRows;

    this.setState({
      checkedRows: checkedAllState ? filteredIds.slice() : [],
      checkedAllRows: checkedAllState
    });
  }

  unCheckAllRows() {
    this.setState({
      checkedRows: [],
      checkedAllRows: false
    });
  }

  afterExport() {
    const { onConfirmation } = this.props;
    this.exportDropdown.hide();
    onConfirmation('Guest List Exported');
  }

  resetFacets() {
    const { onResetFacets, getGuestList } = this.props;
    onResetFacets();
    getGuestList();
  }

  resetAll() {
    const { onResetSearchValue, onResetFacets, onSelectGuestGroup } = this.props; // eslint-disable-line
    onResetSearchValue();
    // onResetFacets();
    onSelectGuestGroup(null);
  }

  selectEventTab(id) {
    const { onSelectEventTab, getGuestList } = this.props;
    this.setState({
      showGuestBreakdown: false
    });
    onSelectEventTab(id);
    getGuestList();
  }

  showAllGuests() {
    const { onResetFacets, onResetSearchValue, getGuestList } = this.props;
    onResetSearchValue();
    onResetFacets();
    getGuestList();
  }

  updateFlowRunId() {
    const { weddingAcctUUID } = this.props;
    this.setState({
      flowRunId: weddingAcctUUID + Date.now().toString()
    });
  }

  render() {
    const {
      wedding,
      guestGroups,
      onEditGuestGroup,
      onToggleFacet,
      globalStats,
      isMapping,
      numGuests,
      numSelectedFacets,
      sortByNameAsc,
      onToggleSort,
      selectedFacetValues,
      onGuestMessage,
      editGuestModalOpen,
      initialized,
      onAddGuestGroup,
      // onEnableGuestListOnboarding, // eslint-disable-line
      onSearchFilterGuestList,
      searchValue,
      filteredIds,
      onSelectGuestGroup,
      selectedGuestGroupId,
      events,
      activeEventTab,
      mealOptions,
      onUpdateEventInvitation,
      onBulkUpdateAllEventInvitations,
      onGetGuestGroupRsvp,
      onUploadSpreadsheet,
    } = this.props;
    if (isMapping) {
      return <MatchGuestList
        onTryAgain={() => onUploadSpreadsheet(this.state.flowRunId, this.updateFlowRunId)}
        flowRunId={this.state.flowRunId}
        updateFlowRunId={this.updateFlowRunId}
        />
    }

    const { checkedRows, checkedAllRows } = this.state;

    if (!initialized) {
      return (
        <div className="guestlist-loader">
          <Loader delay />
        </div>
      );
    }

    // chronologically ordered global stats - the same order as events are in guests table - this may change depending on what product wants
    const formattedGlobalStats = events.orderedIds.map((eventId) => {
      const globalStat = _find(globalStats, { key: `${eventId}` });
      const trimmedEventName = events.byId[eventId].name.length > 30 ? `${events.byId[eventId].name.slice(0, 30)}...` : events.byId[eventId].name;
      if (globalStat) {
        return Object.assign({}, globalStat, { label: `Invited to ${trimmedEventName}` });
      }
      return { key: `${eventId}`, label: `Invited to ${trimmedEventName}`, value: 0 };
    });

    const addEventButton = {
      text: 'Create Your First Event',
      action: () => browserHistory.push('/wedding/manage/events')
    };

    return (
      <div>
        {navRedesign &&  <SecondaryNavV2 activeLinkId={gmPhase1 ? NAV_DATA.SECONDARY.GUEST_LIST.ALL_GUESTS : NAV_DATA.SECONDARY.GUEST_LIST.BUILD} />}
        {numGuests === 0 && (
          <>
            <NoGuestsOnboardFormV2 />
            <NoGuestValueProps />
          </>
        )}
        {numGuests > 0 && (events.orderedIds.length === 0) && (
          <EmptyState
            hed="You Don't Have Any Events Yet!"
            body={<span>Before you jump headfirst into invites, create your first event!<br />Then, you can start building your guest lists.</span>}
            button={addEventButton}
            imgSrc={eventsCalendar}
          />
        )}
        {numGuests > 0 && (events.orderedIds.length > 0) && (
          <div>
            <div className="content-top">
              <div className="row">
                <div className="col-xs-12 navbar-default">
                  <h1 className="page-heading col-xs-12 col-sm-6">Build Guest Lists</h1>
                  <div className="nav navbar-nav navbar-right">
                    <ul className="list-inline">
                      <li className="with-tooltip no-tooltip-on-mobile" data-tooltip="Export guest RSVPs to a spreadsheet.">
                        <Dropdown ref={(c) => { this.exportDropdown = c; }}>
                          <DropdownTrigger className="v2-button secondary-button navbar-btn">Export Invite List <i className="zolaicon zolaicon-chevron-down" /></DropdownTrigger>
                          <DropdownContent className="">
                            <ul className="dropdown-menu dropdown-menu-right">
                              <li>
                                <a href="/web-api/v1/guestgroup/export/build-excel" onClick={this.afterExport}>Excel Format</a>
                              </li>
                              <li>
                                <a href="/web-api/v1/guestgroup/export/build" onClick={this.afterExport}>.csv Format</a>
                              </li>
                            </ul>
                          </DropdownContent>
                        </Dropdown>
                      </li>
                      <li>
                        <div className="with-tooltip no-tooltip-on-mobile" data-tooltip="Manually enter guests, import an existing spreadsheet, or send a link to guests that collects their information.">
                          <ButtonV2 className="navbar-btn" onClick={onAddGuestGroup}>+ Add Guest</ButtonV2>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-xs-12">
                  <div className="global-stats-container build-global-stats">
                    <GlobalStats stats={formattedGlobalStats} />
                  </div>
                </div>
              </div>
              <div className="banner-container">
                {events.rsvpPageHidden ? (
                  <div style={{ backgroundColor: '#F5B7BE', paddingTop: '10px', paddingBottom: '10px', marginBottom: '15px', marginLeft: '-30px', marginRight: '-30px' }}>
                    <div className="text-center">
                      <span className="banner-content">Your wedding website&#39;s RSVP page is hidden, so guests cannot RSVP to any events online.</span>
                      <span className="banner-cta">
                        <Link to="/wedding/manage/website/pages/rsvp" className="zola-ui link link-arrow small">Make Your RSVP Page Visible</Link>
                      </span>
                    </div>
                  </div>
                ) : (
                  <div style={{ backgroundColor: '#C5E3EA', paddingTop: '10px', paddingBottom: '10px', marginBottom: '15px', marginLeft: '-30px', marginRight: '-30px' }}>
                    <div className="text-center">
                      <span className="banner-content">Your wedding website&#39;s RSVP page is visible, so guests can RSVP to events once online RSVP is turned on.</span>
                      <span className="banner-cta">
                        <Link to="/wedding/manage/website/pages/rsvp" className="zola-ui link link-arrow small">Edit RSVP Page</Link>
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="main-content table guest-table">
              <div>
                <div className="col-xs-12 navbar-default navbar-default">
                  <div className="nav navbar-nav navbar-left">
                    {checkedRows.length > 0 ? (
                      <ul className="list-inline">
                        <li>
                          <Dropdown ref={(c) => { this.bulkActionsDropdown = c; }}>
                            <DropdownTrigger className="btn-dropdown btn-dropdown-secondary navbar-btn btn btn-boxed">
                              <div className="visible-xs visible-sm">
                                <span>Bulk Actions</span>
                                <i className="zolaicon zolaicon-chevron-down" />
                              </div>
                              <div className="with-tooltip hidden-xs hidden-sm" data-tooltip="Perform actions on multiple guests at once.">
                                <span>Bulk Actions</span>
                                <i className="zolaicon zolaicon-chevron-down" />
                              </div>
                            </DropdownTrigger>
                            <DropdownContent>
                              <ul className="dropdown-menu dropdown-menu-dark dropdown-menu-left">
                                <li>
                                  <a role="button" onClick={() => { onGuestMessage(checkedRows); this.bulkActionsDropdown.hide(); }}>Send Message</a>
                                </li>
                                <li>
                                  <a role="button" onClick={() => { onBulkUpdateAllEventInvitations(checkedRows, true); this.bulkActionsDropdown.hide(); }}>Invite selected to all events</a>
                                </li>
                                {events.orderedIds.map((eventId) => {
                                  const event = events.byId[eventId];
                                  return (
                                    <li key={eventId}>
                                      <a role="button" onClick={() => { onUpdateEventInvitation(checkedRows, event.id, true); this.bulkActionsDropdown.hide(); }}>Invite to {event.name}</a>
                                    </li>
                                  );
                                })}
                                {events.orderedIds.map((eventId) => {
                                  const event = events.byId[eventId];
                                  return (
                                    <li key={eventId}>
                                      <a role="button" onClick={() => { onUpdateEventInvitation(checkedRows, event.id, false); this.bulkActionsDropdown.hide(); }}>Remove from {event.name}</a>
                                    </li>
                                  );
                                })}
                              </ul>
                            </DropdownContent>
                          </Dropdown>
                        </li>
                        <li>
                          {checkedRows.length} Selected. <a role="button" onClick={this.unCheckAllRows}>Clear Selection</a>
                        </li>
                      </ul>
                    ) : (
                      <ul className="list-inline filter-search-ul-v2">
                        <li>
                          <Dropdown>
                            <DropdownTrigger className="btn-dropdown navbar-btn btn btn-boxed">
                              <div className="hidden-xs hidden-sm">
                                {numSelectedFacets ? (
                                  <span>{numSelectedFacets} Filters Selected</span>
                                ) : (
                                  <div className="with-tooltip" data-tooltip="View specific groups of guests and perform bulk actions."><span>Filter Guests ({numGuests})</span></div>
                                )}
                                <i className="zolaicon zolaicon-chevron-down" />
                              </div>
                              <div className="hidden-md hidden-lg">
                                {numSelectedFacets ? (
                                  <span>{numSelectedFacets} Filters Selected</span>
                                ) : (
                                  <span>Filter Guests ({numGuests})</span>
                                )}
                                <i className="zolaicon zolaicon-chevron-down" />
                              </div>
                            </DropdownTrigger>
                            <DropdownContent className="">
                              <div className="dropdown-menu dropdown-menu-left">
                                <Facets selectedFacetValues={selectedFacetValues} onToggleFacet={onToggleFacet} onResetFacets={this.resetFacets} />
                              </div>
                            </DropdownContent>
                          </Dropdown>
                        </li>
                        <li>
                          <div className="has-feedback has-feedback-left">
                            <span className="zolaicon clear-search hidden" />
                            <i className="glyphicon glyphicon-search form-control-feedback hidden-xs hidden-sm" />
                            <input
                              className="form-control search"
                              type="search"
                              placeholder="Search Guest List"
                              onChange={e => onSearchFilterGuestList(e)}
                              value={searchValue}
                            />
                          </div>
                        </li>
                      </ul>
                    )}
                  </div>
                </div>
              </div>
              <div className="row">
                {filteredIds.length === 0 ? (
                  <div className="col-xs-12 text-center">
                    <h3>No Results Found</h3>
                    <p>Try adjusting your search or filter to find what you&apos;re looking for.</p>
                    <ButtonV2 className="margin-top-2x" onClick={this.showAllGuests}>Show All Guests</ButtonV2>
                  </div>
                ) : (
                  <div className="col-xs-12">
                    <StickyHeaderTable
                      StickyHeader={BuildHeader}
                      StaticTable={BuildTable}
                      dataPropName="guestGroups"
                      stickyHeaderCls="table guest-table-v2"
                      checkAllRows={this.checkAllRows}
                      checkedAllRows={checkedAllRows}
                      sortByNameAsc={sortByNameAsc}
                      onToggleSort={onToggleSort}
                      filteredIds={filteredIds}
                      guestGroups={guestGroups}
                      onEditGuestGroup={onEditGuestGroup}
                      selectedGuestGroupId={selectedGuestGroupId}
                      checkedRows={checkedRows}
                      checkRow={this.checkRow}
                      onSelectGuestGroup={onSelectGuestGroup}
                      editGuestModalOpen={editGuestModalOpen}
                      events={events}
                      activeEventTab={activeEventTab}
                      mealOptions={mealOptions}
                      onUpdateEventInvitation={onUpdateEventInvitation}
                      wedding={wedding}
                      onGetGuestGroupRsvp={onGetGuestGroupRsvp}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

Build.propTypes = {
  wedding: PropTypes.shape({}).isRequired,
  getGuestList: PropTypes.func.isRequired,
  onEditGuestGroup: PropTypes.func.isRequired,
  guestGroups: PropTypes.shape({}),
  globalStats: PropTypes.arrayOf(PropTypes.shape({})),
  numGuests: PropTypes.number,
  numSelectedFacets: PropTypes.number,
  onToggleFacet: PropTypes.func.isRequired,
  sortByNameAsc: PropTypes.bool,
  onToggleSort: PropTypes.func.isRequired,
  onResetFacets: PropTypes.func.isRequired,
  selectedFacetValues: PropTypes.shape({}),
  onGuestMessage: PropTypes.func.isRequired,
  onUnload: PropTypes.func.isRequired,
  onUploadSpreadsheet: PropTypes.func,
  editGuestModalOpen: PropTypes.bool,
  initialized: PropTypes.bool,
  onConfirmation: PropTypes.func,
  onAddGuestGroup: PropTypes.func,
  // onEnableGuestListOnboarding: PropTypes.func,
  getEvents: PropTypes.func,
  onSearchFilterGuestList: PropTypes.func,
  searchValue: PropTypes.string,
  filteredIds: PropTypes.arrayOf(PropTypes.number),
  onResetSearchValue: PropTypes.func,
  onSelectGuestGroup: PropTypes.func,
  selectedGuestGroupId: PropTypes.number,
  events: PropTypes.shape({}),
  activeEventTab: PropTypes.number,
  onSelectEventTab: PropTypes.func,
  mealOptions: PropTypes.shape({}),
  onUpdateEventInvitation: PropTypes.func,
  onBulkUpdateAllEventInvitations: PropTypes.func,
  // onPageToggle: PropTypes.func,
  // showSuccessModal: PropTypes.func,
  // showErrorModal: PropTypes.func,
  onGetGuestGroupRsvp: PropTypes.func
};

const mapStateToProps = state => ({
  activeEventTab: state.guestList.guests.activeEventTab,
  events: state.events.events,
  isMapping: state.guestList.guestImport.isMapping,
  wedding: state.wedding.wedding,
  mealOptions: _flatMap(state.events.events.byId, event => event.meal_options).reduce((result, mealOption) => {
    result[mealOption.id] = mealOption; // eslint-disable-line
    return result;
  }, {})
});

const mapDispatchToProps = dispatch => ({
  getGuestList: () => dispatch(fetchBuildList()),
  onAddGuestGroup: guestGroupType => dispatch(showModal('ADD_GUEST_GROUP', { callback: () => dispatch(fetchBuildList()), guestGroupType, formIdentifier: 'addGuestGroupForm' })),
  onEditGuestGroup: (guestGroupId) => {
    const callback = () => dispatch(fetchBuildList());
    return dispatch(getGuestGroup(guestGroupId))
      .then(() => dispatch(showModal('EDIT_GUEST_GROUP_WEDDING', { guestGroupId, activeTab: 'GUESTS', callback, formIdentifier: 'editGuestGroupForm' })));
  },
  onToggleFacet: (facetKey, facetValue) => dispatch(toggleBuildFacetValue(facetKey, facetValue)),
  onToggleSort: () => {
    dispatch(toggleSortByNameAsc());
    dispatch(fetchBuildList());
  },
  onSelectEventTab: eventId => dispatch(selectEventTab(eventId)),
  onUpdateEventInvitation: (guestGroupIds, eventId, invited, hasRsvpResponses) => {
    if (invited) {
      dispatch(updateEventInvitation(guestGroupIds, eventId, invited));
    } else if (hasRsvpResponses) {
      const onConfirmAction = () => dispatch(updateEventInvitation(guestGroupIds, eventId, invited)).then(() => dispatch(hideModal()));
      dispatch(showModal('BULK_UNINVITE_CONFIRMATION', { onConfirmAction }, { size: 'md' }));
    } else {
      dispatch(updateEventInvitation(guestGroupIds, eventId, invited));
    }
  },
  onBulkUpdateAllEventInvitations: (guestGroupIds, invited) => {
    if (invited) {
      dispatch(bulkUpdateAllEventInvites(guestGroupIds, invited));
    } else {
      const onConfirmAction = () => dispatch(bulkUpdateAllEventInvites(guestGroupIds, invited)).then(() => dispatch(hideModal()));
      dispatch(showModal('BULK_UNINVITE_CONFIRMATION', { onConfirmAction }, { size: 'md' }));
    }
  },
  onGetGuestGroupRsvp: (guestUUID) => { // eslint-disable-line
    return dispatch(getGuestGroupRsvpByUuid(guestUUID));
  },
  onUploadSpreadsheet: (flowRunId, updateFlowRunId) => {
    dispatch(showModal('ADD_GUEST_GROUP', {
      callback: () => dispatch(resetMapping()), // reset data on open… TODO: make a callback available to modals when closing
      formIdentifier: 'addGuestGroupForm',
      activeTab: 'UPLOAD_SPREADSHEET',
      sendLinkVisible: false,
      flowRunId,
      updateFlowRunId,
    },
    { size: 'md' }));
    dispatch(resetMapping());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Build);



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/Build.jsx